import React from 'react';
import AccountingLedgerFilters, { AccountingLedgerFiltersProps } from '../accounting/AccountingLedgerFilters';

type InventoryFiltersProps = Omit<AccountingLedgerFiltersProps, 'view'>;

const InventoryFilters: React.FC<InventoryFiltersProps> = (props) => (
    <AccountingLedgerFilters {...props} view="inventory" />
);

export default InventoryFilters;
